import React, {CSSProperties, FC, memo, useEffect, useState} from "react";
import ContextMenu from "../ContextMenu/ContextMenu";
import {CardContainer, CardContext, CardContextImg, CardText} from "./CardStyle";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {actions as actionsFiles, actions, IFile} from "../../store/sliceFiles";
import FileCheckbox from "../FileCheckbox/FileCheckbox";
import {useNavigate} from "react-router-dom";

import folderImg from "../../image/folder.png"
import {CardProps} from "./CardDefault";
import {config} from "../../config";
import {maxContent} from "../../utils/Util";


const CardFolder: FC<CardProps> = (props) => {

    const {file, checkMode, publicPath} = props
    const dispatch = useDispatch<AppDispatch>();
    const nav = useNavigate();

    const [checked, setChecked] = useState(false)

    useEffect(() => {
        setChecked(false);
    }, [checkMode])

    const showModal = (event: React.MouseEvent<HTMLElement> | React.TouchEvent<HTMLElement>) => {

        if (checkMode) {
            if (checked) {
                dispatch(actionsFiles.removeChecked(file?.id!))
                setChecked(false)
            } else {
                dispatch(actionsFiles.addChecked(file?.id!))
                setChecked(true)
            }
        } else {
            event.preventDefault()
            event.stopPropagation()
            dispatch(actions.clearFile())
            if (file) {
                if (publicPath?.length != null) {
                    nav(`${config.uiStart}/public/files/${publicPath}/${file.id}`)
                } else {
                    nav(`${config.uiStart}/${file.id}`)
                }
            }
        }
    }

    return (
        <CardContainer cheked={checkMode}
            onClick={showModal}
        >
            <CardContext>
                <ContextMenu file={file} isPublic={publicPath?.length != null}>
                    <CardContextImg image={folderImg}>
                        {checkMode &&
                            <FileCheckbox cheked={checked}/>
                        }
                    </CardContextImg>

                </ContextMenu>
            </CardContext>
            <CardText>{maxContent(file?.name)}</CardText>
        </CardContainer>
    )

}

export default memo(CardFolder)
